import { render, staticRenderFns } from "./KPIventas.vue?vue&type=template&id=2e219f24&"
import script from "./KPIventas.vue?vue&type=script&lang=js&"
export * from "./KPIventas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports